import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';
import { BreadcrumbItem } from '@rossum/components/breadcrumbs/Breadcrumbs';
import { Header, HeaderProps } from '@rossum/components/header/Header';
import { Tab, Tabs } from '@rossum/ui/material';
import { SettingsBreadcrumbs } from '../../../containers/Settings/SettingsBreadcrumbs';
import {
  datasetLogsPath,
  datasetSettingsPath,
  datasetsPath,
  datasetTablePath,
} from '../routes';

const tabs = [
  {
    intlKey: 'data',
    to: datasetTablePath,
  },
  {
    intlKey: 'settings',
    to: datasetSettingsPath,
  },
  {
    intlKey: 'logs',
    to: datasetLogsPath,
  },
] as const;

type DatasetsHeaderProps = Omit<HeaderProps, 'breadcrumbs'> & {
  breadcrumbs: BreadcrumbItem[];
  datasetId: string | undefined;
  datasetTab: string | undefined;
};

export const DatasetsHeader = ({
  breadcrumbs,
  datasetId,
  datasetTab,
  ...props
}: DatasetsHeaderProps) => {
  const intl = useIntl();
  const { push } = useHistory();

  const datasetBreadcrumbs: BreadcrumbItem[] = [
    {
      label: intl.formatMessage({
        id: 'features.datasets.list.header.title',
      }),
      to: breadcrumbs.length === 0 ? undefined : datasetsPath(),
    },
    ...breadcrumbs,
  ];

  return (
    <Header
      {...props}
      breadcrumbs={<SettingsBreadcrumbs breadcrumbs={datasetBreadcrumbs} />}
      tabs={
        datasetId ? (
          <Tabs
            value={datasetTab}
            onChange={(_, newValue) => {
              const newTab = tabs.find(tab => tab.intlKey === newValue);

              if (newTab) {
                push(newTab.to(datasetId));
              }
            }}
          >
            {tabs.map(tab => (
              <Tab
                key={tab.intlKey}
                label={intl.formatMessage({
                  id: `features.datasets.${tab.intlKey}.title`,
                })}
                value={tab.intlKey}
                data-cy={`tab-${tab.intlKey}`}
              />
            ))}
          </Tabs>
        ) : null
      }
    />
  );
};
